/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import https from 'https';
import getConfig from '../../config';

// declare var adobeIMS: AdobeIMS;
class SearchAppService {
	/**
	 * Get product details from FFC.
	 * @return Promise JSON object
	 */
	fetchProducts(useCache = false): Promise<any> {
		if (useCache && window.cchome.util.storageAvailable('sessionStorage')) {
			const cached = sessionStorage.getItem(getConfig('SERVICES').searchApp.productsPath);
			if (cached) {
				return Promise.resolve(cached);
			}
		}

		return new Promise((resolve) => {
			this._performCDNProductsRequest().then((data) => {
				if (data && data.apps && window.cchome.util.storageAvailable('sessionStorage')) {
					sessionStorage.setItem(getConfig('SERVICES').searchApp.productsPath, JSON.stringify(data));
				}
				resolve(data);
			});
		});
	}

	/*
	 **
	 **  P R I V A T E   M E T H O D S
	 **
	 */
	static instance: SearchAppService;

	constructor() {
		if (!SearchAppService.instance) {
			SearchAppService.instance = this;
		}
		return SearchAppService.instance;
	}

	/**
	 * Call to Products API from static CDN FFC
	 * @return {Object}
	 */
	_performCDNProductsRequest(): Promise<any> {
		return new Promise((resolve) => {
			const request = https.request(
				{
					hostname: getConfig('SERVICES').searchApp.hostname,
					path: getConfig('SERVICES').searchApp.productsPath,
					method: 'GET',
					headers: {
						'x-api-key': getConfig('CLIENT_ID'),
					},
				},
				(res) => {
					if (res.statusCode && res.statusCode >= 300) {
						window.cchome.util.logger.error(
							'Search App Service',
							'Problem with Search App Service products request',
							res,
						);
						const searchAppServiceError = new Error(`${res.statusCode}`);
						resolve(searchAppServiceError);
					} else {
						let data = '';
						// set the encoding to UTF8 to prevent decoding issues on certain browsers.
						res.setEncoding('utf8');
						res.on('data', (chunk) => (data += chunk));
						res.on('end', () => {
							// Success!
							try {
								resolve(JSON.parse(data));
							} catch (e) {
								resolve(data);
							}
						});
					}
				},
			);

			request.on('error', (err) => {
				// on error, display the search error message
				window.cchome.util.logger.error(
					'Search App Service',
					'Problem with Search App Service products request',
					err.toString(),
				);
				const searchAppServiceError = new Error('_performProductsRequest error');
				resolve(searchAppServiceError);
			});
			request.end();
		});
	}
}

export default SearchAppService;
